import React from 'react'
import { Doughnut } from 'react-chartjs-2'

/**
 * Composant pour le graphique er_supervise (Doughnut)
 */
const ErSuperviseChart = ({ data, options }) => {
  if (!data || !options || !data.labels || !data.datasets) {
    return null
  }

  return (
    <Doughnut
      id="chart_er_supervise"
      options={options}
      data={data}
    />
  )
}

export default ErSuperviseChart
